<span class="navigation__label">
    <span *ngFor="let language of supportedLanguages; let index = index;">
        <span class="cursor-pointer" [class.selected]="language === currentLanguage"
              [ngbTooltip]="tooltips[index]"
              (click)="switchLanguage($event, language)">{{language.toUpperCase()}}</span>
        <span *ngIf="index < supportedLanguages.length - 1" class="mx-1">/</span>
    </span>
</span>
